import * as colors from '@giphy/colors'
import styled from 'styled-components'
import Carousel from '../../../channel/components/stories'

const Container = styled.div`
    border-top: 1px solid ${colors.giphyDarkGrey};
    margin-top: 20px;
    padding: 20px 0;
`

const StoryCarousel = (props) => (
    <Container>
        <Carousel {...props} />
    </Container>
)

export default StoryCarousel
